/* [04] Field Camp: Moss Run, discount mini-game. Self-contained: injects its own CSS + DOM into the kiosk page.
   Params (kiosk URL): ?target=12 leaves to win, ?secs=45 round time, ?gc=FIELDCAMP10 discount code */
(()=>{
if(window.__mossRun)return;window.__mossRun=1;
const P=new URLSearchParams(location.search);
const CFG={code:(P.get('gc')||'FIELDCAMP10').toUpperCase().replace(/[^A-Z0-9_-]/g,''),pct:10,target:Math.max(1,+P.get('target')||12),secs:Math.max(10,+P.get('secs')||45),store:'https://04-studios.com',N:16};
const $=s=>document.querySelector(s);
const lang=()=>(document.documentElement.lang==='en'?'en':'it');
const TX={
 it:{pill:'Gioca per il '+CFG.pct+'%',title:'Moss Run',exit:'Esci',
  introH:'Gioca. Vinci il '+CFG.pct+'%.',
  introP:n=>`Guida il muschio e raccogli ${n} foglie in ${CFG.secs} secondi. Scorri il dito sulla griglia o usa le frecce. Se ti mordi la coda il giro finisce. Se vinci, il ${CFG.pct}% vale su tutti i capi del pop-up.`,
  go:'Gioca',leaves:'Foglie',time:'Tempo',ready:'Pronto',
  winH:'Hai vinto il '+CFG.pct+'%.',winP:'Vale su tutti i capi del pop-up. Inquadra il QR per tenerlo sul telefono, oppure usalo subito qui sul totem.',
  useHere:'Usalo qui sul totem',codeL:'Codice',
  loseH:'Quasi.',loseP:(s,n)=>`Hai raccolto ${s} foglie su ${n}. Un altro giro?`,retry:'Riprova',toMenu:'Vai al menu',
  badge:'−'+CFG.pct+'% applicato al pagamento',
  lb:'Classifica · più veloci',lbEmpty:'Nessun tempo ancora. Sii il primo.',yourT:'Il tuo tempo',namePh:'Il tuo nome',save:'Salva in classifica',saved:'Salvato',ok:'Salva',skip:'Salta',space:'spazio'},
 en:{pill:'Play for '+CFG.pct+'% off',title:'Moss Run',exit:'Close',
  introH:'Play. Win '+CFG.pct+'% off.',
  introP:n=>`Guide the moss and collect ${n} leaves in ${CFG.secs} seconds. Swipe on the grid or use the arrows. Bite your own tail and the run ends. Win and ${CFG.pct}% off applies to every piece at the pop-up.`,
  go:'Play',leaves:'Leaves',time:'Time',ready:'Ready',
  winH:'You won '+CFG.pct+'% off.',winP:'Valid on every piece at the pop-up. Scan the QR to keep it on your phone, or use it right here on the totem.',
  useHere:'Use it on this totem',codeL:'Code',
  loseH:'So close.',loseP:(s,n)=>`You collected ${s} of ${n} leaves. One more go?`,retry:'Try again',toMenu:'Go to menu',
  badge:'−'+CFG.pct+'% applied at payment',
  lb:'Leaderboard · fastest',lbEmpty:'No times yet. Be the first.',yourT:'Your time',namePh:'Your name',save:'Save to leaderboard',saved:'Saved',ok:'Save',skip:'Skip',space:'space'}
};
const t=k=>TX[lang()][k];
/* leaderboard: fastest finishes, kept on this totem */
const LK='fc04_lb';
const lbGet=()=>{try{const a=JSON.parse(localStorage.getItem(LK)||'[]');return Array.isArray(a)?a:[]}catch(e){return[]}};
const lbAdd=(n,tm)=>{try{const a=lbGet();a.push({n:String(n).slice(0,14),t:tm,d:Date.now()});a.sort((x,y)=>x.t-y.t);localStorage.setItem(LK,JSON.stringify(a.slice(0,10)))}catch(e){}};
const esc=x=>String(x).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
function lbRender(){
  const el=document.getElementById('mrLb');if(!el)return;
  const a=lbGet().slice(0,5);
  el.innerHTML='<span class="mr-lbl">'+t('lb')+'</span>'+(a.length?a.map((e,i)=>'<div class="row"><i>'+(i+1)+'</i><span>'+esc(e.n)+'</span><span>'+e.t.toFixed(1)+' s</span></div>').join(''):'<div class="none">'+t('lbEmpty')+'</div>');
}

/* ---------- on-screen keyboard: glass keys over the Moss Engine ---------- */
let kbL=null,kbRaf=0;
function kbHide(){
  const k=document.getElementById('mrKb');if(!k)return;
  cancelAnimationFrame(kbRaf);k.hidden=true;k.innerHTML='';
  if(kbL){try{kbL.cv.remove()}catch(e){}kbL=null}
  root.classList.remove('kb');
}
function kbShow(onChange,onSave,onSkip){
  const k=document.getElementById('mrKb');
  const row=a=>'<div class="kr">'+a+'</div>';
  const key=c=>'<button type="button" data-k="'+c+'">'+c+'</button>';
  const R=['QWERTYUIOP','ASDFGHJKL','ZXCVBNM'];
  k.innerHTML=row(R[0].split('').map(key).join(''))+row(R[1].split('').map(key).join(''))+
    row(R[2].split('').map(key).join('')+'<button type="button" data-k="BS" aria-label="Backspace">⌫</button>')+
    row('<button type="button" class="fn" data-k="SKIP">'+t('skip')+'</button><button type="button" class="sp" data-k=" ">'+t('space')+'</button><button type="button" class="fn go" data-k="OK">'+t('ok')+'</button>');
  k.hidden=false;root.classList.add('kb');
  k.onpointerdown=e=>{
    const b=e.target.closest('button');if(!b)return;e.preventDefault();armIdle();
    const c=b.dataset.k;
    if(c==='OK')onSave();else if(c==='SKIP')onSkip();else onChange(c);
  };
  const e=E();
  if(e){try{
    e.setSeed(1+Math.floor(Math.random()*9999));
    kbL=new e.Layer(k,{lut:e.makeLUT(e.DEF),size:1.3,dir:'up',anchor:'bottom',profile:x=>.7+.3*e.ss(0,1,x)});
    kbL.build();
    const t0=performance.now(),edge=x=>x<=0?0:.25+1.05*x;
    const st=now=>{const p=Math.min(1,(now-t0)/1100),q=p*p*(3-2*p);kbL.paint(q,edge(q));if(p<1)kbRaf=requestAnimationFrame(st)};
    kbRaf=requestAnimationFrame(st);
  }catch(err){}}
}

/* ---------- css ---------- */
const css=document.createElement('style');
css.textContent=`
#mr{position:fixed;inset:0;z-index:50;background:#fff;color:#030302;display:grid;grid-template-rows:auto 1fr;font-family:var(--f-ui,"Inter Tight",Archivo,Helvetica,Arial,sans-serif)}
#mr[hidden]{display:none!important}
#mr .mr-top{height:72px;padding:0 20px;display:flex;align-items:center;gap:14px;border-bottom:1px solid #d9d6cf;background:#fff;position:relative;z-index:2}
#mr .mr-logo{font-weight:700;font-size:24px;letter-spacing:-.04em;line-height:1}
#mr .mr-logo sup{font-size:.42em;letter-spacing:0;margin-left:1px;vertical-align:top;position:relative;top:.1em}
#mr .mr-ttl{margin-left:auto;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#61703a}
#mr .mr-x{min-height:44px;padding:0 18px;border:1px solid #d9d6cf;border-radius:999px;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;background:none;cursor:pointer;color:inherit;font-family:inherit}
#mr .mr-main{position:relative;overflow:hidden;display:grid;place-items:center;padding:16px}
#mr .mr-view{display:grid;gap:18px;justify-items:center;width:100%}
#mr .mr-view[hidden]{display:none!important}
#mr .mr-card{background:#fff;padding:clamp(24px,4vw,44px);width:min(620px,100%);display:grid;gap:20px;justify-items:start;border:1px solid #d9d6cf}
#mr .mr-card h2{font-weight:700;font-size:clamp(34px,6vw,64px);letter-spacing:-.04em;line-height:.98;text-wrap:balance}
#mr .mr-card p{font-size:clamp(16px,1.8vw,19px);max-width:46ch}
#mr .mr-btns{display:flex;gap:10px;flex-wrap:wrap}
#mr .mr-btn{min-height:60px;padding:0 30px;border-radius:999px;border:1px solid #030302;background:#fff;color:#030302;font:700 13px/1 inherit;font-family:inherit;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;display:inline-flex;align-items:center;justify-content:center}
#mr .mr-btn.pri{background:#030302;color:#fff}
#mr .mr-btn.moss{background:#808D45;border-color:#808D45;color:#fff}
#mr .mr-hud{width:var(--bs);display:flex;justify-content:space-between;align-items:flex-end;gap:12px}
#mr .mr-hud b{font-size:clamp(28px,4vw,44px);font-weight:700;letter-spacing:-.04em;line-height:1;font-variant-numeric:tabular-nums}
#mr .mr-hud span{display:block;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#6f6c66;margin-bottom:4px}
#mr .mr-bar{width:var(--bs);height:6px;background:#edebe7;border-radius:999px;overflow:hidden}
#mr .mr-bar i{display:block;height:100%;width:100%;background:#808D45;transform-origin:left;transform:scaleX(1)}
#mr .mr-board{width:var(--bs);height:var(--bs);background:#edebe7;border:1px solid #d9d6cf;position:relative}
#mr canvas.mr-cv{position:absolute;inset:0;width:100%;height:100%;touch-action:none;display:block}
#mr .mr-pad{display:grid;grid-template-columns:repeat(3,76px);grid-template-rows:repeat(2,76px);gap:6px}
#mr .mr-pad button{border:1px solid #d9d6cf;border-radius:50%;background:#fff;font-size:26px;cursor:pointer;color:#030302;touch-action:manipulation}
#mr .mr-pad button:active{background:#808D45;color:#fff;border-color:#808D45}
#mr .mr-pad .u{grid-column:2;grid-row:1}#mr .mr-pad .l{grid-column:1;grid-row:2}#mr .mr-pad .d{grid-column:2;grid-row:2}#mr .mr-pad .r{grid-column:3;grid-row:2}
#mr .mr-qr{display:grid;gap:8px;justify-items:center;padding:14px;border:1px solid #d9d6cf;background:#fff}
#mr .mr-qr svg{width:min(240px,60vw);height:auto;display:block}
#mr .mr-code{font-size:clamp(28px,4vw,40px);font-weight:700;letter-spacing:.04em;line-height:1;font-variant-numeric:tabular-nums}
#mr .mr-lbl{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#6f6c66}
#mr .mr-win{display:grid;gap:20px;justify-items:start}
@media(min-width:700px) and (orientation:landscape){#mr .mr-win{grid-template-columns:auto 1fr;align-items:center;gap:32px}}
#mr .mr-lb{width:min(100%,420px);margin-top:8px;display:grid;gap:0;border-top:1px solid #d9d6cf;padding-top:14px}
#mr .mr-lb .mr-lbl{margin-bottom:8px}
#mr .mr-lb .row{display:grid;grid-template-columns:28px 1fr auto;gap:10px;padding:9px 0;border-bottom:1px solid #eceae5;font-weight:700;font-size:15px;text-transform:uppercase;letter-spacing:.02em;font-variant-numeric:tabular-nums}
#mr .mr-lb .row:first-of-type{color:#61703a;font-size:19px}
#mr .mr-lb .row i{font-style:normal;color:#6f6c66;font-weight:400}
#mr .mr-lb .none{font-size:14px;color:#6f6c66;padding:6px 0}
#mr .mr-nm{display:grid;gap:8px;width:100%;max-width:420px}
#mr .mr-nm .rw{display:flex;gap:8px}
#mr .mr-nm input{flex:1;min-width:0;height:48px;border:1px solid #030302;padding:0 14px;font:inherit;font-size:16px;text-transform:uppercase;border-radius:0;background:#fff}
#mr .mr-field{height:58px;border:1px solid #030302;padding:0 18px;display:flex;align-items:center;font-weight:700;font-size:24px;letter-spacing:.04em;text-transform:uppercase;width:100%;background:#fff}
#mr .mr-field span:empty::before{content:attr(data-ph);color:#a5a29b;font-weight:400}
#mr .mr-field b{width:2px;height:28px;background:#030302;margin-left:3px;animation:mrbl 1s steps(2) infinite}
@keyframes mrbl{50%{opacity:0}}
#mr.kb .mr-win,#mr.kb .mr-card>p{display:none}
#mr.kb .mr-main{padding-bottom:370px;align-items:start;padding-top:28px}
#mrKb{position:absolute;left:0;right:0;bottom:0;z-index:6;isolation:isolate;background:#61703a;padding:18px 12px calc(18px + env(safe-area-inset-bottom,0px));display:grid;gap:8px;justify-items:center;overflow:hidden}
#mrKb[hidden]{display:none!important}
#mrKb .kr{display:flex;gap:8px;justify-content:center;width:100%;max-width:880px}
#mrKb button{flex:1 1 0;max-width:84px;height:clamp(52px,7.4vh,72px);border-radius:18px;border:1px solid rgba(255,255,255,.5);background:rgba(255,255,255,.2);-webkit-backdrop-filter:blur(16px) saturate(1.5);backdrop-filter:blur(16px) saturate(1.5);box-shadow:inset 0 1px 0 rgba(255,255,255,.55),0 4px 14px rgba(3,3,2,.18);color:#fff;font:600 clamp(20px,3vh,26px)/1 inherit;font-family:inherit;letter-spacing:.02em;text-shadow:0 1px 6px rgba(3,3,2,.3);cursor:pointer;touch-action:manipulation;transition:background .12s,transform .12s}
#mrKb button:active{background:rgba(255,255,255,.55);transform:scale(.96)}
#mrKb button.sp{flex:4 1 0;max-width:none;font-size:13px;letter-spacing:.08em;text-transform:uppercase}
#mrKb button.fn{flex:1.6 1 0;max-width:150px;font-size:13px;letter-spacing:.08em;text-transform:uppercase}
#mrKb button.go{background:rgba(255,255,255,.88);color:#030302;text-shadow:none}
#mrBadge{position:fixed;top:84px;right:16px;z-index:9;background:#808D45;color:#fff;padding:8px 14px;border-radius:999px;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;box-shadow:0 1px 8px rgba(3,3,2,.15)}
#mrBadge[hidden]{display:none!important}
.pill.mr-pill{background:#808D45;border-color:#808D45;color:#fff}
@media(max-width:599px){#mr .mr-pad{grid-template-columns:repeat(3,64px);grid-template-rows:repeat(2,64px)}#mr .mr-top{height:60px;padding:0 12px}#mr .mr-logo{font-size:18px}}
`;
document.head.appendChild(css);

/* ---------- dom ---------- */
const root=document.createElement('div');root.id='mr';root.hidden=true;root.setAttribute('role','dialog');root.setAttribute('aria-modal','true');
root.innerHTML=`<div class="mr-top"><div class="mr-logo">[04]-STUDIOS<sup>™</sup></div><span class="mr-ttl" id="mrTtl"></span><button class="mr-x" id="mrX"></button></div>
<div class="mr-main" id="mrMain">
 <div class="mr-view" id="mrIntro"><div class="mr-card"><span class="mr-lbl" id="mrIl">Moss Run</span><h2 id="mrIh"></h2><p id="mrIp"></p><div class="mr-btns"><button class="mr-btn pri" id="mrGo"></button></div><div class="mr-lb" id="mrLb"></div></div></div>
 <div class="mr-view" id="mrPlay" hidden>
  <div class="mr-hud"><div><span id="mrLl"></span><b id="mrScore">0/0</b></div><div style="text-align:right"><span id="mrTl"></span><b id="mrTime">0</b></div></div>
  <div class="mr-bar"><i id="mrBar"></i></div>
  <div class="mr-board" id="mrBoard"><canvas class="mr-cv" id="mrCv"></canvas></div>
  <div class="mr-pad" id="mrPad"><button class="u" data-d="u" aria-label="Su">▲</button><button class="l" data-d="l" aria-label="Sinistra">◀</button><button class="d" data-d="d" aria-label="Giù">▼</button><button class="r" data-d="r" aria-label="Destra">▶</button></div>
 </div>
 <div class="mr-view" id="mrEnd" hidden></div>
<div id="mrKb" hidden></div>
</div>`;
document.body.appendChild(root);
const badge=document.createElement('div');badge.id='mrBadge';badge.hidden=true;document.body.appendChild(badge);

/* ---------- state ---------- */
let ACTIVE=null; /* discount code applied to this kiosk session's checkout */
let S=null,raf=0,idleT=0;
const DIRS={u:[0,-1],d:[0,1],l:[-1,0],r:[1,0]};
const N=CFG.N;
const cv=$('#mrCv'),ctx=cv.getContext('2d');
let CS=0; /* cell size in css px */

function sizeBoard(){
  const bs=Math.floor(Math.max(240,Math.min(innerWidth-32,innerHeight-330,620))/N)*N;
  root.style.setProperty('--bs',bs+'px');
  const dpr=Math.min(2,window.devicePixelRatio||1);
  cv.width=bs*dpr;cv.height=bs*dpr;CS=bs/N;
  ctx.setTransform(dpr,0,0,dpr,0,0);
}

/* moss under the content, growing from the bottom as leaves are collected */
let mossL=null,mossK=0,mossRaf=0;
const E=()=>window.Moss04Engine;
function mossInit(){
  const e=E();if(!e)return;
  if(mossL){mossL.cv.remove();mossL=null}
  e.setSeed(1+Math.floor(Math.random()*9999));
  mossL=new e.Layer(root,{lut:e.makeLUT(e.DEF),size:1.2,dir:'up',anchor:'bottom',profile:x=>e.ss(.5,1,x)});
  mossL.build();mossK=0;mossL.paint(0,0);
}
function mossTo(k,dur){
  if(!mossL)return;const e=E();const edge=x=>x<=0?0:.25+1.05*x;
  cancelAnimationFrame(mossRaf);const from=mossK,t0=performance.now();
  const step=now=>{const p=Math.min(1,(now-t0)/dur),q=p*p*(3-2*p);mossK=from+(k-from)*q;mossL.paint(mossK,edge(mossK));if(p<1)mossRaf=requestAnimationFrame(step)};
  mossRaf=requestAnimationFrame(step);
}

/* ---------- game ---------- */
function newGame(){
  const mid=N>>1;
  S={snake:[{x:mid,y:mid},{x:mid-1,y:mid},{x:mid-2,y:mid}],dir:'r',q:[],leaf:null,score:0,left:CFG.secs,state:'count',cd:3,acc:0,last:0,tick:150,t0:0,tickAcc:0};
  placeLeaf();
}
function placeLeaf(){
  const occ=new Set(S.snake.map(c=>c.x+','+c.y));let x,y,g=0;
  do{x=Math.floor(Math.random()*N);y=Math.floor(Math.random()*N)}while(occ.has(x+','+y)&&++g<500);
  S.leaf={x,y};
}
function turn(d){
  if(!S||S.state==='end')return;
  const last=S.q.length?S.q[S.q.length-1]:S.dir;
  const a=DIRS[last],b=DIRS[d];
  if(a[0]+b[0]===0&&a[1]+b[1]===0)return; /* no reversing */
  if(last===d)return;
  if(S.q.length<2)S.q.push(d);
}
function step(){
  if(S.q.length)S.dir=S.q.shift();
  const d=DIRS[S.dir],h=S.snake[0];
  const n={x:(h.x+d[0]+N)%N,y:(h.y+d[1]+N)%N}; /* walls wrap */
  const eat=S.leaf&&n.x===S.leaf.x&&n.y===S.leaf.y;
  const body=eat?S.snake:S.snake.slice(0,-1);
  if(body.some(c=>c.x===n.x&&c.y===n.y)){end(false,true);return}
  S.snake.unshift(n);
  if(eat){
    S.score++;S.tick=Math.max(95,S.tick-3);
    $('#mrScore').textContent=S.score+'/'+CFG.target;
    mossTo(Math.min(1,S.score/CFG.target),700);
    if(S.score>=CFG.target){end(true);return}
    placeLeaf();
  }else S.snake.pop();
}
function frame(now){
  if(!S||S.state==='end')return;
  const dt=Math.min(100,now-(S.last||now));S.last=now;
  if(S.state==='count'){
    S.acc+=dt;if(S.acc>=700){S.acc=0;S.cd--;if(S.cd<=0){S.state='play';S.t0=now;S.tickAcc=0}}
  }else{
    S.left=Math.max(0,CFG.secs-(now-S.t0)/1000);
    $('#mrTime').textContent=Math.ceil(S.left);
    $('#mrBar').style.transform='scaleX('+(S.left/CFG.secs)+')';
    S.tickAcc+=dt;
    while(S.tickAcc>=S.tick&&S.state==='play'){S.tickAcc-=S.tick;step()}
    if(S.state==='play'&&S.left<=0){end(S.score>=CFG.target);return}
  }
  draw();
  raf=requestAnimationFrame(frame);
}
function rr(x,y,w,h,r){ctx.beginPath();ctx.roundRect?ctx.roundRect(x,y,w,h,r):ctx.rect(x,y,w,h);ctx.fill()}
function draw(){
  const bs=CS*N;ctx.clearRect(0,0,bs,bs);
  ctx.strokeStyle='rgba(3,3,2,.05)';ctx.lineWidth=1;ctx.beginPath();
  for(let i=1;i<N;i++){ctx.moveTo(i*CS,0);ctx.lineTo(i*CS,bs);ctx.moveTo(0,i*CS);ctx.lineTo(bs,i*CS)}ctx.stroke();
  if(S.leaf){const p=CS*.18;ctx.fillStyle='#7fa36a';rr(S.leaf.x*CS+p,S.leaf.y*CS+p,CS-2*p,CS-2*p,CS*.5);ctx.fillStyle='#61703a';rr(S.leaf.x*CS+CS*.42,S.leaf.y*CS+CS*.12,CS*.16,CS*.3,2)}
  S.snake.forEach((c,i)=>{
    const p=i?CS*.1:CS*.04;ctx.fillStyle=i===0?'#030302':(i%2?'#808D45':'#61703a');
    rr(c.x*CS+p,c.y*CS+p,CS-2*p,CS-2*p,CS*.28);
  });
  if(S.state==='count'){
    ctx.fillStyle='rgba(255,255,255,.72)';ctx.fillRect(0,0,bs,bs);
    ctx.fillStyle='#030302';ctx.font='700 '+Math.round(bs*.3)+'px '+getComputedStyle(root).fontFamily;ctx.textAlign='center';ctx.textBaseline='middle';
    ctx.fillText(String(Math.max(1,S.cd)),bs/2,bs/2);
  }
}
function view(v){['Intro','Play','End'].forEach(n=>{$('#mr'+n).hidden=n!==v})}
function start(){
  cancelAnimationFrame(raf);clearTimeout(idleT);
  view('Play');sizeBoard();newGame();
  $('#mrScore').textContent='0/'+CFG.target;$('#mrTime').textContent=CFG.secs;$('#mrBar').style.transform='scaleX(1)';
  mossInit();
  S.last=performance.now();raf=requestAnimationFrame(frame);
}
function end(win,crash){
  S.state='end';cancelAnimationFrame(raf);
  if(win)mossTo(1,900);
  const sc=S.score,el=$('#mrEnd'),tm=S.t0?(performance.now()-S.t0)/1000:CFG.secs;
  if(win){
    const link=`${CFG.store}/discount/${CFG.code}?redirect=/pages/field-camp`;
    let qr='';
    if(window.qrcode){try{const q=qrcode(0,'M');q.addData(link,'Byte');q.make();qr=q.createSvgTag({cellSize:8,margin:2,scalable:true})}catch(e){}}
    el.innerHTML=`<div class="mr-card"><span class="mr-lbl">Moss Run · ${sc}/${CFG.target}</span><h2>${t('winH')}</h2><p>${t('winP')}</p>
      <div class="mr-nm" id="mrNmBox"><span class="mr-lbl">${t('yourT')} · ${tm.toFixed(1)} s</span><div class="mr-field"><span id="mrNmT" data-ph="${t('namePh')}"></span><b></b></div></div>
      <div class="mr-win"><div class="mr-qr">${qr||''}<span class="mr-lbl">${t('codeL')}</span><span class="mr-code">${CFG.code}</span></div>
      <div class="mr-btns" style="flex-direction:column;align-items:stretch"><button class="mr-btn moss" id="mrUse">${t('useHere')}</button><button class="mr-btn" id="mrOut">${t('exit')}</button></div></div></div>`;
    let NM='';
    const done=saved=>{kbHide();const bx=$('#mrNmBox');if(!bx)return;if(saved){lbAdd(NM,tm);bx.innerHTML='<span class="mr-lbl">'+t('saved')+' · '+esc(NM)+' · '+tm.toFixed(1)+' s</span>'}else bx.remove();armIdle()};
    kbShow(c=>{if(c==='BS')NM=NM.slice(0,-1);else if(NM.length<14)NM+=c;$('#mrNmT').textContent=NM},
      ()=>{if(NM.trim()){NM=NM.trim();done(true)}else done(false)},()=>done(false));
    $('#mrUse').onclick=()=>{ACTIVE=CFG.code;showBadge();close(true)};
    $('#mrOut').onclick=()=>close(false);
  }else{
    el.innerHTML=`<div class="mr-card"><span class="mr-lbl">Moss Run</span><h2>${t('loseH')}</h2><p>${t('loseP')(sc,CFG.target)}</p>
      <div class="mr-btns"><button class="mr-btn pri" id="mrRe">${t('retry')}</button><button class="mr-btn" id="mrOut">${t('toMenu')}</button></div></div>`;
    $('#mrRe').onclick=start;$('#mrOut').onclick=()=>close(true);
  }
  view('End');armIdle();
}
function showBadge(){badge.textContent=t('badge');badge.hidden=!ACTIVE}
function armIdle(){clearTimeout(idleT);idleT=setTimeout(()=>close(false),60000)}
function close(toMenu){
  cancelAnimationFrame(raf);cancelAnimationFrame(mossRaf);clearTimeout(idleT);S=null;
  root.hidden=true;kbHide();
  if(mossL){mossL.cv.remove();mossL=null}
  if(toMenu){const b=$('#attStart');if(b)b.click()}
}
function open(){
  root.hidden=false;view('Intro');labels();armIdle();
}
function labels(){
  $('#mrTtl').textContent=t('title');$('#mrX').textContent=t('exit');
  $('#mrIh').textContent=t('introH');$('#mrIp').textContent=t('introP')(CFG.target);$('#mrGo').textContent=t('go');
  $('#mrLl').textContent=t('leaves');$('#mrTl').textContent=t('time');
  const pill=$('#mrPill');if(pill)pill.textContent=t('pill');
  lbRender();showBadge();
}

/* ---------- input ---------- */
$('#mrGo').onclick=start;
$('#mrX').onclick=()=>close(false);
$('#mrPad').addEventListener('pointerdown',e=>{const b=e.target.closest('button');if(b){e.preventDefault();turn(b.dataset.d)}});
let sw=null;
cv.addEventListener('pointerdown',e=>{sw={x:e.clientX,y:e.clientY};cv.setPointerCapture&&cv.setPointerCapture(e.pointerId)});
cv.addEventListener('pointermove',e=>{
  if(!sw)return;const dx=e.clientX-sw.x,dy=e.clientY-sw.y;
  if(Math.max(Math.abs(dx),Math.abs(dy))>22){turn(Math.abs(dx)>Math.abs(dy)?(dx>0?'r':'l'):(dy>0?'d':'u'));sw={x:e.clientX,y:e.clientY}}
});
['pointerup','pointercancel'].forEach(ev=>cv.addEventListener(ev,()=>{sw=null}));
document.addEventListener('keydown',e=>{
  if(root.hidden||(e.target&&e.target.tagName==='INPUT'))return;
  const m={ArrowUp:'u',ArrowDown:'d',ArrowLeft:'l',ArrowRight:'r',w:'u',s:'d',a:'l',d:'r'}[e.key];
  if(m){e.preventDefault();turn(m)}else if(e.key==='Escape')close(false);
});
root.addEventListener('pointerdown',()=>{if(S&&S.state!=='end')return;armIdle()});
addEventListener('resize',()=>{if(!root.hidden&&S){sizeBoard();mossInit()}});

/* ---------- hook into the kiosk ---------- */
function inject(){
  const pills=$('#s-attract .pills');if(!pills||$('#mrPill'))return;
  const b=document.createElement('button');b.className='pill mr-pill';b.id='mrPill';b.textContent=t('pill');
  b.addEventListener('click',e=>{e.stopPropagation();open()});
  pills.prepend(b);
}
inject();
new MutationObserver(()=>labels()).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
/* every new session (attract screen visible again) drops the discount */
const att=$('#s-attract');
if(att)new MutationObserver(()=>{if(!att.hidden){ACTIVE=null;showBadge()}}).observe(att,{attributes:true,attributeFilter:['hidden']});

/* the discount rides along: phone QR (cart permalink) gets ?discount=, on-screen checkout gets /checkout?discount= */
if(typeof window.qrcode==='function'){
  const orig=window.qrcode;
  window.qrcode=function(){
    const q=orig.apply(this,arguments),add=q.addData;
    q.addData=function(d,m){
      if(ACTIVE&&typeof d==='string'&&d.indexOf('/cart/')>-1)d+=(d.indexOf('?')>-1?'&':'?')+'discount='+encodeURIComponent(ACTIVE);
      return add.call(q,d,m);
    };
    return q;
  };
  Object.keys(orig).forEach(k=>{window.qrcode[k]=orig[k]});
}
document.addEventListener('click',e=>{
  const a=e.target.closest&&e.target.closest('#payHere');
  if(!a||!ACTIVE)return;
  e.preventDefault();e.stopImmediatePropagation();
  a.classList.add('busy');
  location.href='/checkout?discount='+encodeURIComponent(ACTIVE);
},true);
})();
